import { atom } from "jotai";
/** null = not logged in, undefined = not checked yet. */
export const currentUserAtom = atom(undefined);
